// extracted by mini-css-extract-plugin
module.exports = {"event-tab":"selected-widgets_event-tab__30HaN"};